import { createContext, useCallback, useEffect, useState } from "react";
import izenuAPI from "../services/izenuAPI";

export const UserContext = createContext(null);

const UserContextProvider = ({ children }) => {

    const [theUser, setUser] = useState(null);
    const [wait, setWait] = useState(false);
    //Track player data
    const [currentTrack, setCurrentTrack] = useState("empty");



    const loginAdminUser = async ({ email, password }) => {
        setWait(true);
        try {
            const { data } = await izenuAPI.post('login.php', {
                email,
                password
            });
            if (data.success && data.token) {
                localStorage.setItem('loginToken', data.token);
                setWait(false);
                return { success: 1 };
            }
            setWait(false);
            return { success: 0, message: data.message };
        }
        catch (err) {
            setWait(false);
            return { success: 0, message: 'Server Error!' };
        }

    }

    const loggedInCheck = async () => {
        const loginToken = localStorage.getItem('loginToken');
        //Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

        if (loginToken) {
            const { data } = await izenuAPI.get('getUser.php');
            if (data.success && data.user) {
                setUser(data.user);
                return;
            }
            setUser(null);
        }
    }

    useEffect(() => {
        async function asyncCall() {
            await loggedInCheck();
        }
        asyncCall();
    }, []);

    const logout = () => {
        localStorage.removeItem('loginToken');
        setUser(null);
    }

    return (
        <UserContext.Provider value={{ currentTrack, setCurrentTrack, user: theUser, setUser, loginAdminUser, logout }}>
            {children}
        </UserContext.Provider>
    );

}

export default UserContextProvider;